<template>
  <footer class="footer">
    <div class="footer-left">
      <span
        >This Demo Page is demonstrating the key features<template>
          of Betby Sportsbook</template
      >. <span v-if="!isPresentation" >To add demo-money press Top up.</span></span
      ><br />
      <span
        >Sportsbook has a fully customizable design, you can tune up colors and
        layout by pressing</span
      >
      <img src="/static/layout-icon.svg" alt="" />
      <span>To change Color Theme press</span>
      <img src="/static/icon-color.svg" alt="" /><br />
      <span>Choose between Card</span
      ><img src="/static/icon-layout-card.svg" alt="" /><span>Sidebar</span>
      <img src="/static/icon-layout-sidebar.svg" alt="" /><span>Classic</span>
      <img src="/static/icon-layout-classic.svg" alt="" /><span>layouts.</span
      ><img src="/static/icon-refresh.svg" alt="" /><span
        >shows the next randomly generated design.</span
      ><br />
      <div class="footer-ask-hint">
        <span>Press</span><img src="/static/icon-ask.svg" alt="" /><span
          >to ask us about the product, and we will contact you back.</span
        >
      </div>
      <div class="copyright">
        <a href="//betby.com" target="_blank">betby.com</a><br />
        info@betby.com<br />
        Copyright © {{ currentYear }} Earlybird Ltd, Betby™
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
import Btn from "./Btn";
import RefreshIcon from "./icons/RefreshIcon";

export default {
  name: "Footer",
  components: {
    Btn,
    RefreshIcon,
  },
  computed: {
    ...mapState("app", ["isPresentation"]),
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 24px;
  background-color: #172329;
  font-size: 12px;
  color: #8e989d;
  letter-spacing: 0.3px;
  line-height: 1.5;
}

.footer-left {
  flex: 1;
}
.footer-left span,
.footer-left img {
  vertical-align: middle;
  margin-right: 8px;
}
.copyright {
  margin-top: 24px;
  line-height: 1.8;
}
.copyright a {
  color: #8e989d;
  text-decoration: none;
}
.copyright a:hover {
  color: #fff;
}

@media (max-width: 1023px) {
  .footer {
    flex-direction: column;
    padding-bottom: 64px;
    align-items: flex-start;
  }
  .footer-left {
    flex-direction: column;
  }
}
@media (max-width: 600px) {
  .footer-ask-hint {
    display: none;
  }
}
</style>
